import React from "react";
import { MainLayout } from "src/apps/commons/layouts";
import { ListContainers } from "src/apps/modules/remyndCategoryPartnerMap";

const Page = () => <ListContainers />;
Page.Layout = MainLayout;
export default Page;
